import { Suspense, type FC } from 'react';

import { CenterContainer } from '@xing-com/platform-layout-view-wrapper';
import { spaceXL } from '@xing-com/tokens';

import { useCompaniesArticles } from '../../hooks/use-companies-articles/use-companies-articles';

import * as Styled from './section-companies-insights.styles';

const LIMIT = 3;

const SectionCompaniesInsightsInner: FC = () => {
  const { data } = useCompaniesArticles({ limit: LIMIT });

  const companyArticles = data?.companyArticles?.collection?.filter(
    (company) => {
      const { details } = company ?? {};
      return Boolean(details?.title) || Boolean(details?.image);
    }
  );

  const contentCardContent = companyArticles?.map((article) => ({
    title: article?.details?.title ?? '',
    description: article?.details?.description ?? '',
    readingTime: article?.readingTime,
    image: article?.details?.image,
    bgColor: article?.bgColor,
    href: article?.details?.url ?? undefined,
    to: article?.details?.url ?? undefined,
  }));

  if (!companyArticles?.length) return null;

  return (
    <CenterContainer>
      <Styled.CarouselSection
        titleKey="CP_INSIGHTS_SECTION_TITLE"
        subtitleKey="CP_INSIGHTS_SECTION_SUBLINE"
        variant="custom"
        useFullWidth
        itemWidth="284px"
        itemWidthWide="752px"
        itemWidthConfined="649px"
        paddingBottom={spaceXL}
        paddingTop={spaceXL}
      >
        {contentCardContent?.map((data, index) => (
          <Styled.ContentCard
            data-testid={`company-insight-card-${index}`}
            key={index}
            variant="hero"
            {...data}
          />
        ))}
      </Styled.CarouselSection>
    </CenterContainer>
  );
};

export const SectionCompaniesInsights: FC = () => {
  return (
    <Suspense fallback={null}>
      <SectionCompaniesInsightsInner />
    </Suspense>
  );
};
